<template>
    <div>
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-8 offset-2">
                        <h1 class="header__title">First step</h1>
                    </div>
                </div>
            </div>
        </header>

        <section class="container animated fadeIn">
            <div class="intro-content pt--40">
                <div class="profile profile--vertical profile--lg mb--20">
                    <figure class="profile__avatar">
                        <span class="profile__avatar__img">
                            <img :src="avatar" alt="" />
                        </span>
                    </figure>
                </div>
            </div>
            <router-link to="/game/level-test" class="btn btn--block btn--yellow mb--md">Take our level test</router-link>
            <router-link to="/" class="btn btn--block btn--primary mb--md">Go to Dashboard</router-link>
        </section>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "AfterRegistration",
    computed: {
        ...mapGetters('auth', [
            'avatar',
        ]),
    }
}
</script>